// extracted by mini-css-extract-plugin
module.exports = {"bookend":"BookendControls-module__bookend___10eNC","icon":"BookendControls-module__icon___3wNHP","settings":"BookendControls-module__settings___3EFi5"};